<template>
  <LayoutLegal title="California Privacy Chart">
    <template #sidebar>
      <ul class="flex flex-col gap-6 leading-snug">
        <li><a href="#1">Identifiers</a></li>
        <li>
          <a href="#2">
            Personal information categories listed in the California Customer
            Records statute
          </a>
        </li>
        <li>
          <a href="#3">
            Protected classification characteristics under California or federal
            law
          </a>
        </li>
        <li><a href="#4">Commercial information</a></li>
        <li><a href="#5">Biometric information</a></li>
        <li><a href="#6">Internet or other similar network activity</a></li>
        <li><a href="#7">Geolocation data</a></li>
        <li><a href="#8">Sensory data</a></li>
        <li><a href="#9">Professional or employment-related information</a></li>
        <li>
          <a href="#10">
            Non-public education information (per the Family Educational Rights
            and Privacy Act
          </a>
        </li>
        <li>
          <a href="#11">Inferences drawn from other personal information</a>
        </li>
      </ul>
    </template>

    <h2>California Privacy Chart</h2>

    <table>
      <thead>
        <tr>
          <th>Legal Category</th>
          <th>Types of Information Collected</th>
          <th>Source</th>
          <th>Purposes for Collection and Use</th>
          <th>Sharing with Third Parties for a Business Purpose</th>
        </tr>
      </thead>
      <tbody>
        <tr id="1">
          <td>A. Identifiers.</td>
          <td>
            Real name, alias, postal address, unique personal identifier, online
            identifier, Internet Protocol address, email address, account name,
            Social Security number, driver’s license number, passport number, or
            other similar identifiers.
          </td>
          <td>
            <ul>
              <li>Directly from you</li>
              <li>Automatically from your devices</li>
              <li>From third parties</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Identity Verification</li>
              <li>Importing Contacts</li>
              <li>Providing Platform and Services</li>
              <li>Communication Features</li>
              <li>Questions and Inquiries</li>
              <li>Security</li>
              <li>Website Improvement and Optimization</li>
              <li>Advertising and Marketing</li>
              <li>Purchases and Payments</li>
              <li>Third-Party Sign-In</li>
              <li>Customized Content</li>
              <li>Contextual and Behavioral Advertising</li>
              <li>Research</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Friends and Other Users</li>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business</li>
              <li>Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="2">
          <td>
            B. Personal information categories listed in the California Customer
            Records statute (Cal. Civ. Code § 1798.80(e)).
          </td>
          <td>
            Name, signature, Social Security number, physical characteristics or
            description, address, telephone number, passport number, driver’s
            license or state identification card number, insurance policy
            number, education, employment, employment history, bank account
            number, credit card number, debit card number, or any other
            financial information, medical information, or health insurance
            information. Some personal information included in this category may
            overlap with other categories.
          </td>
          <td>
            <ul>
              <li>Directly from you</li>
              <li>Automaticall y from your devices</li>
              <li>From third parties</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Identity Verification</li>
              <li>Importing Contacts</li>
              <li>Providing Platform and Services</li>
              <li>Communication Features</li>
              <li>Questions and Inquiries</li>
              <li>Security</li>
              <li>Website Improvement and Optimization</li>
              <li>Advertising and Marketing</li>
              <li>Purchases and Payments</li>
              <li>Third-Party Sign-In</li>
              <li>Customized Content</li>
              <li>Contextual and Behavioral</li>
              <li>Advertising</li>
              <li>Research</li>
            </ul>
          </td>
          <td>
            <ul>
              Friends and Other
              <li>Users</li>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business</li>
              <li>Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="3">
          <td>
            C. Protected classification characteristics under California or
            federal law.
          </td>
          <td>
            Age (40 years or older), race, color, ancestry, national origin,
            citizenship, religion or creed, marital status, medical condition,
            physical or mental disability, sex (including gender, gender
            identity, gender expression, pregnancy or childbirth and related
            medical conditions), sexual orientation, veteran or military status,
            genetic information (including familial genetic information).
          </td>
          <td>
            <ul>
              <li>Directly from you</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Identity Verification</li>
              <li>Third-Party Sign-In</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Friends and Other</li>
              <li>Users</li>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business</li>
              <li>Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="4">
          <td>D. Commercial information.</td>
          <td>
            Records of personal property, products or services purchased,
            obtained, or considered, or other purchasing or consuming histories
            or tendencies.
          </td>
          <td>
            <ul>
              <li>Directly from you</li>
              <li>Automatically from your devices</li>
              <li>From third parties</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Providing Platform and Services</li>
              <li>Advertising and Marketing</li>
              <li>Purchases and Payments</li>
              <li>Customized Content</li>
              <li>Contextual and Behavioral Advertising</li>
              <li>Research</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="5">
          <td>E. Biometric information.</td>
          <td>
            Genetic, physiological, behavioral, and biological characteristics,
            or activity patterns used to extract a template or other identifier
            or identifying information, such as, fingerprints, faceprints, and
            voiceprints, iris or retina scans, keystroke, gait, or other
            physical patterns, and sleep, health, or exercise data.
          </td>
          <td>
            <ul>
              <li>Directly from you</li>
              <li>Automatically from your devices</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Identity Verification</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="6">
          <td>F. Internet or other similar network activity.</td>
          <td>
            Browsing history, search history, information on a consumer’s
            interaction with a website, application, or advertisement.
          </td>
          <td>
            <ul>
              <li>Automatically from your devices</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Providing Platform and Services</li>
              <li>Communication Features</li>
              <li>Questions and Inquiries</li>
              <li>Security</li>
              <li>Website Improvement and Optimization</li>
              <li>Advertising and Marketing</li>
              <li>Purchases and Payments</li>
              <li>Customized Content</li>
              <li>Contextual and Behavioral Advertising</li>
              <li>Research</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Friends and Other Users</li>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="7">
          <td>G. Geolocation data.</td>
          <td>Physical location or movements.</td>
          <td>
            <ul>
              <li>Automatically from your devices</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Providing Platform and Services</li>
              <li>Security</li>
              <li>Website Improvement and Optimization</li>
              <li>Advertising and Marketing</li>
              <li>Purchases and Payments</li>
              <li>Third-Party Sign-In</li>
              <li>Customized Content</li>
              <li>Contextual and Behavioral Advertising</li>
              <li>Research</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Friends and Other Users</li>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business Structure or Ownership</li>
            </ul>
          </td>
        </tr>
        <tr id="8">
          <td>H. Sensory data.</td>
          <td>
            Audio, electronic, visual, thermal, olfactory, or similar
            information.
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
        </tr>
        <tr id="9">
          <td>I. Professional or employment-related information.</td>
          <td>Current or past job history or performance evaluations.</td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
        </tr>
        <tr id="10">
          <td>
            J. Non-public education information (per the Family Educational
            Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part
            99)).
          </td>
          <td>
            Education records directly related to a student maintained by an
            educational institution or party acting on its behalf, such as
            grades, transcripts, class lists, student schedules, student
            identification codes, student financial information, or student
            disciplinary records.
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Not collected</li>
            </ul>
          </td>
        </tr>
        <tr id="11">
          <td>K. Inferences drawn from other personal information.</td>
          <td>
            Profile reflecting a person’s preferences, characteristics,
            psychological trends, predispositions, behavior, attitudes,
            intelligence, abilities, and aptitudes.
          </td>
          <td>
            <ul>
              <li>Automatically from your devices</li>
              <li>From third parties</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Using the Platform</li>
              <li>Providing Platform and Services</li>
              <li>Security</li>
              <li>Website Improvement and Optimization</li>
              <li>Advertising and Marketing</li>
              <li>Purchases and Payments</li>
              <li>Third-Party Sign-In</li>
              <li>Customized Content</li>
              <li>Contextual and Behavioral Advertising</li>
              <li>Research</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Third-Party Advertising</li>
              <li>Safety, Security, and Compliance</li>
              <li>Service Providers</li>
              <li>Changes in Business Structure or Ownership</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <p>
      * We may also collect your information to comply with laws or regulations
      or with legal requests that don't fit into one of the categories we've
      described for you.
    </p>

    <p>
      + We share the following categories of information about you for business
      purposes:
    </p>

    <ul class="leading-loose">
      <li>A. Identifiers</li>
      <li>B. California Customer Records Categories</li>
      <li>C. Protected Classifications</li>
      <li>D. Commercial Information</li>
      <li>E. Biometric Information Personal Information</li>
      <li>F. Internet Activity</li>
      <li>G. Geolocation</li>
      <li>K. Inferences Drawn from Other</li>
    </ul>
  </LayoutLegal>
</template>

<script setup>
  definePageMeta({
    skipAuth: true,
  })

  useHead({
    title: "California Privacy Chart - favoritely.com",
    meta: [{ name: "description", content: "favoritely.com" }],
  })
</script>

<style lang="scss" scoped>
  table {
    thead {
      tr {
        th {
          @apply font-bold align-top;
        }
      }
    }

    td {
      @apply align-top;

      width: 20%;

      ul {
        @apply list-disc ml-6;
      }
    }
  }
</style>
